export default __webpack_public_path__ + "static/media/guL3ueiZygXNDxB0SM9j7A3T2iA2.dff56982.jpg";